import type { IFilter } from '@models/Filter'
import { endOfDay, startOfDay } from '@util/date-util'

import { apiClient } from '../../../gateways/api'
import type {
  HoofdnetOpdrachtenSearch,
  HoofdnetOpdrachtenSearchFilters,
} from '../types/HoofdnetOpdrachtenSearch'

export { initialState, createFilters, searchHoofdnetOpdrachten }

const initialState: HoofdnetOpdrachtenSearch = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: {
      type: null,
      opdrachtgever: null,
      opdrachtnemer: null,
      discipline: null,
      search: '',
      searchOption: null,
      versieNummer: null,
      open: true,
      creatiedatum: null,
      changed: null,
    },
    sort: { sortBy: 'changed', sortDirection: 'desc' },
    page: { skip: 0, limit: 25 },
  },
}

const createFilters = ({
  type,
  discipline,
  opdrachtgever,
  opdrachtnemer,
  versieNummer,
  open,
  creatiedatum,
  changed,
  search,
  searchOption,
}: HoofdnetOpdrachtenSearchFilters) => {
  const filters: IFilter[] = []

  if (type) filters.push({ name: 'type', value: type, operator: 'eq' })
  if (discipline)
    filters.push({ name: 'discipline', value: discipline.code, operator: 'eq' })
  if (opdrachtgever)
    filters.push({
      name: 'opdrachtgever',
      value: opdrachtgever,
      operator: 'eq',
    })
  if (opdrachtnemer)
    filters.push({
      name: 'opdrachtnemer',
      value: opdrachtnemer,
      operator: 'eq',
    })
  if (versieNummer)
    filters.push({ name: 'versieNummer', value: versieNummer, operator: 'eq' })
  if (open) filters.push({ name: 'status', value: 900, operator: 'lt' })

  if (creatiedatum) {
    filters.push({
      name: 'creatiedatum',
      value: startOfDay(creatiedatum),
      operator: 'gte',
    })
    filters.push({
      name: 'creatiedatum',
      value: endOfDay(creatiedatum),
      operator: 'lte',
    })
  }

  if (changed) {
    filters.push({
      name: 'changed',
      value: startOfDay(changed),
      operator: 'gte',
    })
    filters.push({ name: 'changed', value: endOfDay(changed), operator: 'lte' })
  }

  if (search && search !== '') {
    if (searchOption)
      filters.push({ name: searchOption.k, value: search, operator: 'eq' })
    else filters.push({ name: 'text', value: search, operator: 'contains' })
  }

  return filters
}

const searchHoofdnetOpdrachten = async ({
  query,
}: {
  query: HoofdnetOpdrachtenSearch['query']
}): Promise<HoofdnetOpdrachtenSearch['data']> => {
  const { filters, page, sort } = query

  const { data } = await apiClient({
    url: '/rest/opdracht-hoofdnet/search',
    method: 'POST',
    data: { filters: createFilters(filters), ...page, ...sort },
  })

  return data
}
